import React from "react";
import { useSelector } from "react-redux";

import { DocumentPreferences } from "./DocumentPreferences";

export function DocumentPreferencesContainer() {
    const { allDeliveryOptions, currentPreferences, clientPreferencesRequestStatus, isAdviser } =
        useSelector(state => ({
            allDeliveryOptions: state.user.preferences.availableOptions?.allDeliveryOptions,
            currentPreferences: state.user.preferences.correspondenceDelivery?.currentPreferences,
            clientPreferencesRequestStatus: state.requests.clientPreferences,
            isAdviser: Boolean(state.user.adviserId)
        }));

    return (
        <DocumentPreferences
            allDeliveryOptions={allDeliveryOptions}
            currentPreferences={currentPreferences}
            clientPreferencesRequestStatus={clientPreferencesRequestStatus}
            isAdviser={isAdviser}
        />
    );
}
